export default {
  'en-US': {
    eCommercePlatforms: {
      Shopify: 'Shopify',
      Amazon: 'Amazon',
      WooCommerce: 'WooCommerce',
      Walmart: 'Walmart',
      Magento: 'Magento',
      BigCommerce: 'BigCommerce',
      Wix: 'Wix',
      ShipStation: 'ShipStation',
      eBay: 'eBay',
      CrateJoy: 'Cratejoy',
      StitchLabs: 'StitchLabs',
      SquareSpace: 'Squarespace',
      Crowdfunding: 'Crowdfunding (e.g. Kickstarter)',
      Other: 'Other',
      NotSure: 'Not sure'
    }
  }
}
